import {Component, Inject, Input, LOCALE_ID, OnInit} from '@angular/core';
import {ZaverecnaPraca} from '../model/zaverecnaPraca';
import {AppService} from '../app.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import {Error} from 'ais-common';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-zaverecna-praca',
  templateUrl: './zaverecna-praca.component.html',
  styleUrls: ['./zaverecna-praca.component.css']
})
export class ZaverecnaPracaComponent implements OnInit {

  @Input()
  zaverecnaPraca: ZaverecnaPraca;

  loading = false;

  constructor(
    private appService: AppService,
    private http: HttpClient,
    @Inject(LOCALE_ID) private locale: string,
    private translate: TranslateService
  ) { }

  ngOnInit() {
  }

  odhlasit() {
    this.appService.openConfirmDialog(this.translate.instant('Naozaj odhlásiť z práce?'))
      .subscribe(res => {
        if (res === 'OK') {
          this.http.get(
            '/ais/rest/portal/zaverecne-prace/odhlasit',
            {
              params: {
                idStudium: this.zaverecnaPraca.idStudium.toString(),
                idTema: this.zaverecnaPraca.idTema.toString()
              }
            }).subscribe(
            out => {
              this.appService.fetchStudia(true);
            },
            (err) => {
              this.appService.openErrorDialog(err.error.message);
            }
          );
        }
      });
  }

  detailZadania() {
    this.appService.openPortalAppWindow(
      'ais.gui.vs.es.VSES060_DetailZaverecnejPraceDlg',
      'ro' + this.zaverecnaPraca.idTema
    );
  }

  detailPraceHodnoteniePosudok() {
    this.appService.openPortalAppWindow(
      'ais.gui.vs.es.VSES111_TemaZavPraceDlg',
      this.zaverecnaPraca.idStudium + '/' + this.zaverecnaPraca.idTema
    );
  }

  tlacPrihlasky() {
    this.loading = true;

    this.http
      .post(
        '/ais/rest/portal/zaverecne-prace/prihlaska/' + this.zaverecnaPraca.idTema +
        '/lng/' + this.locale.toUpperCase(),
        {},
        {observe: 'events', responseType: 'arraybuffer'})
      .subscribe(
        (res) => {
          if (res instanceof HttpResponse) {
            const blob = new Blob([res.body], {type: 'application/pdf'});
            const fileName = 'prihlaska-zp_' + this.zaverecnaPraca.idTema + '.pdf';
            FileSaver.saveAs(blob, fileName);
            this.loading = false;
          }
        },
        (error: Error) => {
          this.appService.openErrorDialog(this.translate.instant('Prihlášku sa nepodarilo vytlačiť.'));
          this.loading = false;
        }
      );
  }

  tlacZadania(lng: string = this.locale) {
    this.loading = true;

    this.http
      .post(
        '/ais/rest/portal/zaverecne-prace/zadanie/' + this.zaverecnaPraca.idTema +
        '/lng/' + lng.toUpperCase(),
        {},
        {observe: 'events', responseType: 'arraybuffer'})
      .subscribe(
        (res) => {
          if (res instanceof HttpResponse) {
            const blob = new Blob([res.body], {type: 'application/pdf'});
            const fileName = 'zadanie-zp_' + this.zaverecnaPraca.idTema + '.pdf';
            FileSaver.saveAs(blob, fileName);
            this.loading = false;
          }
        },
        (err) => {
          if ('TextDecoder' in window) {
            const enc = new TextDecoder('utf-8');
            const jsonError = JSON.parse(enc.decode(err.error));
            this.appService.openErrorDialog(this.translate.instant(jsonError.message));
          }
          else {
            this.appService.openErrorDialog(this.translate.instant('Zadanie sa nepodarilo vytlačiť.'));
          }
          this.loading = false;
        }
      );
  }
}
